import { useSession } from 'src/hooks';
import { useGetOfferInfoUserIdQuery } from 'src/store/services';
import { useMemo } from 'react';
import { OfferType } from 'src/types/wallet/models/OfferType';
import { ThreeMonthsFreeSubscriptionExtensionOfferDetails } from 'src/types/wallet/models/ThreeMonthsFreeSubscriptionExtensionOfferDetails';
import { TwoMonthExtendedSubscriptionCancellationOfferDetails } from 'src/types/wallet/models/TwoMonthExtendedSubscriptionCancellationOfferDetails';

export const useOfferInfo = () => {
  const { appUser, isOpenTier } = useSession();

  const { data: offerInfo, isLoading: isOfferInfoLoading } =
    useGetOfferInfoUserIdQuery(
      {
        user_id: appUser.user_id,
      },
      {
        skip: isOpenTier,
      },
    );

  const oneMonthFreeOffer = useMemo(() => {
    return offerInfo?.offer_details.find(
      (item) =>
        item.offer_type === OfferType.ONE_MONTH_FREE_SUBSCRIPTION_EXTENSION,
    );
  }, [offerInfo]);

  const twoMonthAfterCancelOffer = useMemo(() => {
    return offerInfo?.offer_details.find(
      (item) =>
        item.offer_type ===
        OfferType.TWO_MONTH_EXTENDED_SUBSCRIPTION_CANCELLATION,
    ) as TwoMonthExtendedSubscriptionCancellationOfferDetails;
  }, [offerInfo]);

  const threeMonthsFreeOffer = useMemo(() => {
    return offerInfo?.offer_details.find(
      (item) =>
        item.offer_type === OfferType.THREE_MONTHS_FREE_SUBSCRIPTION_EXTENSION,
    ) as ThreeMonthsFreeSubscriptionExtensionOfferDetails;
  }, [offerInfo]);

  return useMemo(
    () => ({
      offerInfo,
      oneMonthFreeOffer,
      threeMonthsFreeOffer,
      twoMonthAfterCancelOffer,
      isOfferInfoLoading,
    }),
    [
      offerInfo,
      isOfferInfoLoading,
      oneMonthFreeOffer,
      threeMonthsFreeOffer,
      twoMonthAfterCancelOffer,
    ],
  );
};
